export default __webpack_public_path__ + "static/media/TicketingFees.f31d2f3a.jpg";